import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import { CPUserBus } from '../models/CPUserBus';
import * as _ from 'lodash';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs';
import { AppCategory } from '../enums/AppCategories';
import { AppFunction } from '../models/AppFunction';
import { GItem } from '../models/GItem';
import { Address } from '../models/Address';
import { GeographyInfoBus } from '../models/GeographyInfoBus';
import { BaseMessageInfo } from '../models/BaseMessageInfo';
import { CustomerBus } from '../models/CustomerBus';
import { CustomerContactBus } from '../models/CustomerContactBus';
import { CustomerPricingBus } from '../models/CustomerPricingBus';
import { BillingCodeRatesBus } from '../models/BillingCodeRatesBus';
import { CustomerProceduresBus } from '../models/CustomerProceduresBus';
import { CustomerInventoryBus } from '../models/CustomerInventoryBus';
import { TItem } from '../models/TItem';
import { LocationInventoryXREFBus } from '../models/LocationInventoryXREFBus';
import { BillingCodeRatesBusView } from '../models/BillingCodeRatesBusView';
import { CustomerInvoiceChecklistBus } from '../models/CustomerInvoiceChecklistBus';
import { LocBillingCodeRatesBus } from '../models/LocBillingCodeRatesBus';
import { CustomerDispatchStatistics } from '../models/CustomerDispatchStatistics';
import { FileInfo } from '@progress/kendo-angular-upload';
import { CustomerDispatchStatisticsDetail } from '../models/CustomerDispatchStatisticsDetail';
import { CommonParam } from '../models/CommonParam';
import { LocationPricingBus } from '../models/LocationPricingBus';
import { SubCategoryMarkUpBus } from '../models/SubCategoryMarkUpBus';
import { CompanyPricingBus } from '../models/CompanyPricingBus';
import { CustomerInvoiceBillingCodeBus } from '../models/CustomerInvoiceBillingCodeBus';
import { CustomerInvoiceBillingCodeMarkupBus } from '../models/CustomerInvoiceBillingCodeMarkupBus';
import { LocationContractNotesBus } from '../models/LocationContractNotesBus';
import { PotentialCustomerBus } from '../models/PotentialCustomerBus';
import { v_DispatchAttachmentBus } from '../models/v_DispatchAttachmentBus';
import { v_InvoiceCheckListAttachmentBus } from '../models/v_InvoiceCheckListAttachmentBus';

@Injectable({
    providedIn: 'root',
})
export class CustomerService extends BaseService {
    private _currentCategory = new BehaviorSubject<AppFunction>(new AppFunction());
    public currentCategory$: Observable<AppFunction> = this._currentCategory.asObservable();

    constructor(_http: HttpClient) {
        super(_http);
        this.baseUrl = this.rootUrl + "Customer/";
    }
    private testSubject = new BehaviorSubject('Value 1');
    test$: Observable<string> = this.testSubject.asObservable();

    getLogo(customerId: string): Observable<Blob> {
        const url = `${this.baseUrl}GetLogo/${customerId}`;
        return this._http.get(url, {
            responseType: 'blob'
        });
    }
    getCustomer(id: string): Observable<CustomerBus> {
        let url_call: string = this.baseUrl + "Get/" + id;
        return this.get(url_call);
    }
    getPotentialCustomer(id: string): Observable<PotentialCustomerBus> {
        let url_call: string = this.baseUrl + "GetPotentialCustomer/" + id;
        return this.get(url_call);
    }
    getBillingCode(): Observable<GItem[]> {
        let url_call: string = this.baseUrl + "GetBillingCodesForCBO";
        return this.get(url_call);
    }
    getCustomerContacts(id: string): Observable<CustomerContactBus[]> {
        let url_call: string = this.baseUrl + "GetContacts/" + id;
        return this.get(url_call);
    }
    getLocationInventoryXREF(id: string): Observable<LocationInventoryXREFBus[]> {
        let url_call: string = this.baseUrl + "getLocationInventoryXREF/" + id;
        return this.get(url_call);
    }
    getLocationInventoryXREFHistory(id: string): Observable<LocationInventoryXREFBus[]> {
        let url_call: string = this.baseUrl + "getLocationInventoryXREFHistory/" + id;
        return this.get(url_call);
    }
    getLocationPricing(id: string): Observable<LocationPricingBus[]> {
        let url_call: string = this.baseUrl + "GetLocationPricing/" + id;
        return this.get(url_call);
    }
    getLocationPricingHistory(id: string): Observable<LocationPricingBus[]> {
        let url_call: string = this.baseUrl + "GetLocationPricingHistory/" + id;
        return this.get(url_call);
    }
    getCustomerProcedures(id: string): Observable<CustomerProceduresBus[]> {
        let url_call: string = this.baseUrl + "GetProcedures/" + id;
        return this.get(url_call);
    }
    getCustomerInventory(id: string): Observable<CustomerInventoryBus[]> {
        let url_call: string = this.baseUrl + "getInventory/" + id;
        return this.get(url_call);
    }
    getCustomerInventoryHistory(id: string): Observable<CustomerInventoryBus[]> {
        let url_call: string = this.baseUrl + "getInventoryHistory/" + id;
        return this.get(url_call);
    }
    GetCPFeatures(): Observable<TItem[]> {
        let url_call: string = this.baseUrl + "GetCPFeatures";
        return this.get(url_call);
    }
    getCustomerPricing(id: string): Observable<CustomerPricingBus[]> {
        let url_call: string = this.baseUrl + "GetPricing/" + id;
        return this.get(url_call);
    }
    getCustomerPricingHistory(id: string): Observable<CustomerPricingBus[]> {
        let url_call: string = this.baseUrl + "GetPricingHistory/" + id;
        return this.get(url_call);
    }
    getCompanyPricing(id: string): Observable<CompanyPricingBus[]> {
        let url_call: string = this.baseUrl + "GetCompanyPricing/" + id;
        return this.get(url_call);
    }
    getGubCategoryMarkUp(id: string): Observable<SubCategoryMarkUpBus[]> {
        let url_call: string = this.baseUrl + "GetSubCategoryMarkUp/" + id;
        return this.get(url_call);
    }
    getGubCategoryMarkUpHistory(id: string): Observable<SubCategoryMarkUpBus[]> {
        let url_call: string = this.baseUrl + "GetSubCategoryMarkUpHistory/" + id;
        return this.get(url_call);
    }
    subCategoryMarkUp
    getBillingCodeRates(id: string): Observable<BillingCodeRatesBus[]> {
        let url_call: string = this.baseUrl + "GetBillingCodeRates/" + id;
        return this.get(url_call);
    }
    getBillingCodeRatesHistory(id: string): Observable<BillingCodeRatesBus[]> {
        let url_call: string = this.baseUrl + "GetBillingCodeRatesHistory/" + id;
        return this.get(url_call);
    }
    getCustomerInvoiceBillingCodes(id: string): Observable<CustomerInvoiceBillingCodeBus[]> {
        let url_call: string = this.baseUrl + "GetCustomerInvoiceBillingCodes/" + id;
        return this.get(url_call);
    }
    getCustomerLocationInvoiceBillingCodes(id: string): Observable<CustomerInvoiceBillingCodeBus[]> {
        let url_call: string = this.baseUrl + "getCustomerLocationInvoiceBillingCodes/" + id;
        return this.get(url_call);
    }
    getCustomerInvoiceBillingCodeMarkups(id: string): Observable<CustomerInvoiceBillingCodeMarkupBus[]> {
        let url_call: string = this.baseUrl + "GetCustomerInvoiceBillingCodeMarkups/" + id;
        return this.get(url_call);
    }
    getCustomerLocationInvoiceBillingCodeMarkups(id: string): Observable<CustomerInvoiceBillingCodeMarkupBus[]> {
        let url_call: string = this.baseUrl + "getCustomerLocationInvoiceBillingCodeMarkups/" + id;
        return this.get(url_call);
    }

    GetBillingCodeRatesLocation(id: string): Observable<LocBillingCodeRatesBus[]> {
        let url_call: string = this.baseUrl + "GetBillingCodeRatesLocation/" + id;
        return this.get(url_call);
    }
    GetBillingCodeRatesLocationHistory(id: string): Observable<LocBillingCodeRatesBus[]> {
        let url_call: string = this.baseUrl + "GetBillingCodeRatesLocationHistory/" + id;
        return this.get(url_call);
    }
    GetLocationContractNotes(id: string): Observable<LocationContractNotesBus[]> {
        let url_call: string = this.baseUrl + "GetLocationContractNotes/" + id;
        return this.get(url_call);
    }
    getCustomerInvoiceChecklists(id: string): Observable<CustomerInvoiceChecklistBus[]> {
        let url_call: string = this.baseUrl + "GetCustomerInvoiceChecklists/" + id;
        return this.get(url_call);
    }
    getCompanyDefaultInvoiceChecklist(id: string): Observable<CustomerInvoiceChecklistBus[]> {
        let url_call: string = this.baseUrl + "GetCompanyDefaultInvoiceChecklist/" + id;
        return this.get(url_call);
    }
    getBillingCodeRatesView(customerId: string, locationId: string): Observable<BillingCodeRatesBusView[]> {
        let url_call: string = this.baseUrl + "BillingCodeRatesBusView/" + customerId;
        if (locationId) {
            url_call = this.baseUrl + "BillingCodeRatesBusView/" + customerId + "/" + locationId;;
        }

        return this.get(url_call);
    }
    GetLocationProfile(id: string, topN: number = 5, spentLastNMonths: number = 6): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationProfile/" + id + "/" + topN + "/" + spentLastNMonths;
        return this.get(url_call);

    }
    getUserProfile(id: string): Observable<CPUserBus> {
        let url_call: string = this.baseUrl + "GetUserProfile/" + id;
        return this.get(url_call);

    }
    getUserFeatures(id: string): Observable<GItem> {
        let url_call: string = this.baseUrl + "UserFeatures/" + id;
        return this.get(url_call);

    }
    getUserLocations(id: string): Observable<GItem> {
        let url_call: string = this.baseUrl + "UserLocations/" + id;
        return this.get(url_call);

    }

    getLocationDetail(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationDetail/" + id;
        return super.get(url_call);
    }
    getLocation(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocation/" + id;
        return super.get(url_call);
    }

    getPotentialLocation(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetPotentialLocation/" + id;
        return super.get(url_call);
    }

    getLocationUnionXrefs(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetLocationUnionXrefs/" + id;
        return super.get(url_call);
    }

    getInvoiceCheckListNotes(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoiceCheckListNotes/" + id;
        return super.get(url_call);
    }

    getInvoiceCheckListAttachments(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetInvoiceCheckListAttachments/" + id;
        return super.get(url_call);
    }

    setAppCategory(category: AppCategory) {
        let appFunction = new AppFunction(category);
        this._currentCategory.next(appFunction);
    }
    isLoggedIn() {
        return true;
    }
    hasRole(role: string): boolean {
        return true;
    }
    changeTest(v: string) {
        this.testSubject.next(v);
    }
    updateUserProfile(id: string, busObj: CPUserBus) {
        let url_call: string = this.baseUrl + "UpdateUserProfile/";
        return this.put(url_call, id, busObj);
    }

    getCustomersForCBO(): Observable<GItem[]> {
        let url_call: string = this.baseUrl + "GetCustomersForCBO";
        return this.get(url_call);
    }
    getCustomerUsersForCBO(id: string): Observable<GItem[]> {
        let url_call: string = this.baseUrl + "GetCustomerUsersForCBO/" + id;
        return this.get(url_call);
    }
    getCustomerLocationsForCBO(id: string): Observable<GItem[]> {
        let url_call: string = this.baseUrl + "GetCustomerLocationsForCBO/" + id;
        return this.get(url_call);
    }

    getPotentialCustomerLocationsForCBO(id: string): Observable<GItem[]> {
        let url_call: string = this.baseUrl + "GetPotentialCustomerLocationsForCBO/" + id;
        return this.get(url_call);
    }

    getCustomerDispatchStatistics(id: string): Observable<CustomerDispatchStatistics[]> {
        let url_call: string = this.baseUrl + "GetCustomerDispatchStatistics/" + id;
        return this.get(url_call);
    }
    getCustomerDispatchStatisticDetails(id: string): Observable<CustomerDispatchStatisticsDetail[]> {
        let url_call: string = this.baseUrl + "GetCustomerDispatchStatisticDetails/" + id;
        return this.get(url_call);
    }
    getGeographyAddress(id: string): Observable<Address> {
        let url_call: string = this.baseUrl + "GetGeographyAddress/" + id;
        return this.get(url_call);
    }
    getGeographyInfo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetGeographyInfo/" + id;
        return this.get(url_call);
    }
    getCustomDownloadReferenceData(): Observable<BaseMessageInfo> {
        let url_call: string = this.baseUrl + "GetCustomDownloadReferenceData";
        return this.get(url_call);
    }
    getCusLocAddrInfo(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCusLocAddrInfo/" + id;
        return this.get(url_call);
    }
    getTaxCode(id: string, includeInactive: boolean): Observable<any> {
        let url_call: string = this.baseUrl + "GetTaxCode/" + id + "/" + (includeInactive ? "true" : "false");
        return super.get(url_call);
    }
    getTaxLines(includeInactive: boolean = false): Observable<any> {
        let url_call: string = this.baseUrl + "GetTaxLines/" + (includeInactive ? "true" : "false");
        return super.get(url_call);
    }

    GetCustomerCustomForms(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCustomerCustomForms/" + id;
        return super.get(url_call);
    }
    saveAll(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveAll";
        return this._http.put(url_call, model, { headers });
    }

    savePotentialCustomer(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SavePotentialCustomer";
        return this._http.post(url_call, model, { headers });
    }

    uploadLogo(files: FileInfo[], customerId: string): Observable<any> {
        let url: string = this.baseUrl + "UploadLogo/" + customerId;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        return this._http.put(url, formData);
    }
    uploadAttachment(files: FileInfo[], data: v_InvoiceCheckListAttachmentBus): Observable<any> {
        let url: string = this.baseUrl + "UploadAttachment";
        let dataStr: string = JSON.stringify(data);
        //we dont need to send the bytes if its filled out cause we are posting the file
        data.attachment = null;
        const formData = new FormData();

        for (const file of files) {
            formData.append('files', file.rawFile, file.name);
        }

        formData.append("AttachmentData", dataStr);
        return this._http.put(url, formData);
    }
    saveNote(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "InvoiceCheckListNote_Save";
        return this._http.put(url_call, model, { headers });
    }
    deleteNote(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "InvoiceCheckListNote_Delete/";
        return super.delete(url_call, id);
    }
    deleteAttachment(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeleteAttachment/";
        return super.delete(url_call, id);
    }
    getInvoiceCheckListDocument(Id: string) {
        let url_call: string = this.baseUrl + "GetDocument/" + Id;
        return super.get(url_call); //, { headers: headers });
    }
    saveUser(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "UpdateUserProfile";
        return this._http.put(url_call, model, { headers });
    }
    updateLocation(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "UpdateLocation";
        return this._http.put(url_call, model, { headers });
    }

    updatePotentialLocation(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "UpdatePotentialLocation";
        return this._http.post(url_call, model, { headers });
    }

    GetCustomerPms(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCustomerPms/" + id;
        return super.get(url_call);
    }
    GetCustomerQuestions(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCustomerQuestions/" + id;
        return super.get(url_call);
    }
    GetCustomerLocationPMs(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCustomerLocationPMs/" + id;
        return super.get(url_call);
    }
    GetCustomerInventoryPMs(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "GetCustomerInventoryPMs/" + id;
        return super.get(url_call);
    }
    saveTaxCode(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveTaxCode";
        return this._http.put(url_call, model, { headers });
    }
    saveTaxLine(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveTaxLine";
        return this._http.put(url_call, model, { headers });
    }
    deleteTaxLine(id: string): Observable<any> {
        let url_call: string = this.baseUrl + "DeleteTaxLine/";
        return super.delete(url_call, id);
    }
    CloneRates(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "CloneRates";
        return this._http.put(url_call, model, { headers });
    }
    getPricingForAck(id: string, type: number): Observable<any> {
        let url_call: string = this.baseUrl + "getPricingForAck/" + id + "/" + type;
        return this.get(url_call);
    }
    updatePricingForAck(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "UpdatePricingForAck";
        return this._http.put(url_call, model, { headers });
    }
    updatePricingForAckLoc(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "UpdatePricingForAckLoc";
        return this._http.put(url_call, model, { headers });
    }

    getShipToLocations(): Observable<any> {
        let url_call: string = this.baseUrl + "locations/ship-to";
        return this.get(url_call);
    }
}
